//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryArticeList } from '../../assets/js/select'
export default {
  name: 'article',
  data () {
    return {
      top: 0,
      dataList:[]
    }
  },
  methods: {
    onClickLeft () {
      this.$router.goBack()
    },
    addZero (n) {
      return n < 10 ? '0' + n : n
    },
    //时间格式化
    transferTime (timestamp) {
      return new Date(parseFloat(timestamp)).toLocaleString()
    },
    toDetail (item) {
      localStorage.setItem('detail', JSON.stringify(item))
      this.$router.push({
        path: '/articleDetail'
      })
    },
    getList () {
      queryArticeList().then(res => {
        this.dataList = res.data
      })
    }
  },
  created () {
    if (this.$global.isApp) {
      this.top = api.safeArea.top
    }
    this.getList()
  }
}



// WEBPACK FOOTER //
// ./src/pages/Create/article.vue